import { API, Auth } from 'aws-amplify'

async function getRoster () {
  let myInit = {
    response: false,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getIdToken()
        .getJwtToken()}`
    }
  }

  return API.get('mctcuser', '/roster', myInit)
}

async function updateRoster (args) {
  try {
    const updatedRoster = {}
    updatedRoster[args.year] = {}
    updatedRoster[args.year][args.month] = {}
    updatedRoster[args.year][args.month][args.day] = args.roster

    let myInit = {
      response: false,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`
      },
      body: {
        updatedRoster
      }
    }

    return API.post('mctcuser', '/roster', myInit)
  } catch (e) {
    console.log('API.POST update roster ERROR')
    console.log(e)
    throw e
  }
}

async function loadRoster (userid, newtitle) {
  return getRoster()
}

export default {
  loadRoster,
  updateRoster
}
